import { render } from "./ActivateCmmi.vue?vue&type=template&id=2fd49766&ts=true"
import script from "./ActivateCmmi.vue?vue&type=script&lang=ts"
export * from "./ActivateCmmi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__